<template>
  <div>
    <div class="">
      <div class="filter">
        <el-form
          :inline="true"
          @submit.native.prevent
          :model="filter"
          ref="filterForm"
          label-position="right"
          label-width="100px"
          size="small"
          class="oneline"
        >
          <el-form-item label="返回状态" prop="status">
            <el-select v-model="filter.status" multiple clearable collapse-tags>
              <el-option :value="1" label="待接收"></el-option>
              <el-option :value="3" label="已接收"></el-option>
              <el-option :value="2" label="已拒收"></el-option>
              <el-option :value="0" label="空"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="成品类型" prop="code_type">
            <el-select v-model="filter.code_type" clearable>
              <el-option :value="1" label="有编号"></el-option>
              <el-option :value="2" label="无编号"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="成品分类">
            <TemplateSelect
              v-model="filter.product_template_id"
              :category="category"
            ></TemplateSelect>
          </el-form-item>
          <el-form-item label="接收开始日期" prop="date">
            <el-date-picker
              v-model="filter.start_date"
              value-format="yyyy-MM-dd"
              placeholder="请选择"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="返回结束日期" prop="date">
            <el-date-picker
              v-model="filter.end_date"
              value-format="yyyy-MM-dd"
              placeholder="请选择"
            >
            </el-date-picker>
          </el-form-item>
          <!-- <el-form-item>
            <el-button
              type="primary"
              size="small"
              @click="
                filter.page = 1
                getData()
              "
              >筛选</el-button
            >
            <el-button size="small" @click="getData(true)">重置</el-button>
          </el-form-item> -->
        </el-form>
      </div>
    </div>
    <div class="">
      <div
        style="
          display: flex;
          justify-content: space-between;
          padding-left: 100px;
          margin-top: 10px;
        "
      >
        <div>
          <el-button
            type="primary"
            size="small"
            @click="
              filter.page = 1
              getData()
            "
            >筛选</el-button
          >
          <el-button size="small" @click="getData(true)">重置</el-button>
        </div>

        <file-button
          obj="well_stock_record"
          :filter="queryData"
          :importButton="false"
        ></file-button>
      </div>
      <Table
        :items="items.list"
        :category="category"
        :loading="loading"
      ></Table>
      <el-pagination
        class="mt-20"
        :page-size="filter.size"
        :current-page.sync="filter.page"
        @current-change="getData(false)"
        layout="total, prev, pager, next"
        :total="items.count"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { productWellPeriodList } from '@/service/getData'
import Table from './table'
import TemplateSelect from '@/components/select/product_template_select'

export default {
  props: {
    category: {
      type: Number,
      default: 0,
    },
    wellid: Number,
  },
  components: {
    Table,
    TemplateSelect,
  },
  computed: {
    queryData() {
      let data = this.clone(this.filter)
      data.category = this.category
      data.drill_well_id = this.wellid
      data.is_well_stock_list = true
      data.page -= 1
      return data
    },
  },
  data() {
    return {
      loading: false,
      filter: {
        product_template_id: '',
        start_date: '',
        end_date: '',
        page: 1,
        size: 10,
        status: '',
        code_type: '',
      },
      items: {
        list: [],
        count: 0,
      },
    }
  },
  created() {
    this.getData()
  },
  methods: {
    async getData(reset = false) {
      if (reset) {
        this.filter.page = 1
        this.filter.product_template_id = ''
        this.filter.start_date = ''
        this.filter.end_date = ''
        this.filter.status = ''
        this.filter.code_type = ''
      }

      this.loading = true
      let res = await productWellPeriodList(this.queryData)
      if (res.status != 0) return false
      this.items = res.data
      this.loading = false
    },
  },
}
</script>